import {
    type FilterType,
    type ModelFilterGradeType,
    ProaceFilterType,
} from "../../../../../common-deprecated/types/CommonTypes";
import { setModelFilterValue } from "../../redux/actions/ModelFilterActions";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../redux/store";
import { searchModelMapValue } from "../../../../../common-deprecated/settings/utils/commonSettingUtils";
import { modelIsLcv } from "../../../../shared-logic/utils/lcvUtils";
import { useDispatch } from "../../../../../shared-logic/redux/store";

export type UseProAceFiltersType = {
    modelId: string;
    checkBoxFilters: FilterType[];
    filteredCarGrades: ModelFilterGradeType[];
    seatFilter?: FilterType & { code: ProaceFilterType.SeatsCount };
    disabledWheelBase?: boolean;
    setFilterValue: (filterCode: string, value: string) => void;
};

const useProAceFilters = (): UseProAceFiltersType => {
    const { filters, filteredGrades, dimensions } = useBnbSelector((state) => state.modelFilter);
    const modelId = useBnbSelector(
        (state) => searchModelMapValue(state.commonSettings, state.navigation.model)?.id || "",
    );
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    // Add a model object which contains the model id.
    // We're adding this to keep the AddToCompare action which expects a modelid in the grade object working.
    // Don't forget to also calculate in any additional selectedOptions in the price!
    const filteredCarGrades = filteredGrades.map((carGrade) => {
        // Check if there are selectedOptions, if so create a sum of all the selectedOption's prices in addition to the price of the grade
        const basePrice = carGrade.selectedOptions.reduce(
            (acc, { price }) => {
                acc.cash += price.cash;
                acc.discount += price.discount;
                acc.exclVat += price.exclVat;
                acc.monthly += price.monthly;
                acc.promotions = acc.promotions.concat(price.promotions);
                return acc;
            },
            { ...carGrade.price },
        );
        return {
            ...carGrade,
            price: basePrice,
            model: { id: modelId },
        };
    });

    const checkBoxFilters = filters.filter((filter) => filter.code !== ProaceFilterType.SeatsCount);
    const seatFilter = filters.find((filter) => filter.code === ProaceFilterType.SeatsCount);

    // Wheelbaseview should be disabled when no relevant data is present.
    const disabledWheelBase = modelIsLcv(modelId)
        ? dimensions.capacity.length === 0
        : // legacy reasonss
          dimensions.capacity.length === 0 && (dimensions as any).dimensions.length === 0;

    return {
        modelId,
        checkBoxFilters,
        filteredCarGrades,
        seatFilter: seatFilter as UseProAceFiltersType["seatFilter"],
        disabledWheelBase,
        setFilterValue: (filterCode: string, value: string) => dispatch(setModelFilterValue(filterCode, value)),
    };
};

export default useProAceFilters;
